import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthSliceState } from '../../models/user';

export const selectAuthState = createFeatureSelector<AuthSliceState>('auth');

export const selectUser = createSelector(selectAuthState, (state) => state.user);
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state) => !!state.token && !!state.user
);
export const selectAuthError = createSelector(selectAuthState, (state) => state.error);
export const selectAuthLoading = createSelector(selectAuthState, (state) => state.loading);
export const selectAuthMessage = createSelector(selectAuthState, (state) => state.message);

export const selectUserRoles = createSelector(
  selectUser,
  (user) => user?.roles || []
);

export const selectUserPermissions = createSelector(
  selectUser,
  (user) => user?.permissions || []
);


export const selectHasRole = (role: string) =>
  createSelector(selectUserRoles, (roles) => roles.includes(role));

export const selectHasAnyRole = (roles: string[]) =>
  createSelector(selectUserRoles, (userRoles) =>
    roles.some(role => userRoles.includes(role))
  );

export const selectHasPermission = (permission: string) =>
  createSelector(selectUserPermissions, (permissions) =>
    permissions.includes(permission)
  );

export const selectHasAnyPermission = (permissions: string[]) =>
  createSelector(selectUserPermissions, (userPermissions) =>
    permissions.some(perm => userPermissions.includes(perm))
  );

export const selectHasAllPermissions = (permissions: string[]) =>
  createSelector(selectUserPermissions, (userPermissions) =>
    permissions.every(perm => userPermissions.includes(perm))
  );
